import { render, staticRenderFns } from "./POTransactionPanel.vue?vue&type=template&id=dd1dc812&scoped=true"
import script from "./POTransactionPanel.vue?vue&type=script&lang=js"
export * from "./POTransactionPanel.vue?vue&type=script&lang=js"
import style0 from "./POTransactionPanel.vue?vue&type=style&index=0&id=dd1dc812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1dc812",
  null
  
)

export default component.exports